import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { IoMdArrowDropright, IoMdLeaf } from "react-icons/io";
import { FaShieldAlt, FaCog, FaMapMarkerAlt, FaCalendarAlt, FaArrowRight } from "react-icons/fa";

import banner1 from "../assets/kinemo.jpeg";
import banner2 from "../assets/ppe.jpg";
import banner3 from "../assets/banner3.jpg";
import banner4 from "../assets/packaging.jpg";

export default function HomeBanner1() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [bgIndex, setBgIndex] = useState(0);

  const banners = [banner2, banner1, banner3, banner4];

  useEffect(() => setReady(true), []);
  useEffect(() => {
    if (!ready) return;
    const interval = setInterval(() => {
      setBgIndex((prev) => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [ready]);

  if (!ready) return <div className="container mSupportLoading">{getInlineLoader()}</div>;

  return (
    <section
      className="MainBodySection"
      style={{ position: "relative", overflow: "hidden" }}
    >
      <div
        style={{
          height: "calc(100vh - var(--topBarHeight))",
          position: "relative",
        }}
      >
        {/* Background Slides */}
        {banners.map((banner, i) => (
          <div
            key={i}
            style={{
              backgroundImage: `url(${banner})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "absolute",
              inset: 0,
              opacity: i === bgIndex ? 1 : 0,
              transition: "opacity 1.6s ease-in-out",
              filter: "brightness(0.3)",
            }}
          />
        ))}

        {/* Overlay Content */}
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            padding: "0 16px",
          }}
        >
          <div
            className="container d-flex flex-column  justify-content-between"
          >
            <div className="d-flex flex-column flex-md-row gap-3 mb-3 text-shadow" data-aos="fade-up">
              <h6>
                CLIMATE RESILIENT AGRIBUSINESS SOLUTIONS
              </h6>
            </div>

            {/* Main Text */}
            <div className="col-lg-7 mb-4 mb-lg-0" style={{ flex: 1 }}>
               <h1
                className="text-light font-bold"
                style={{
                  letterSpacing: "1.2px",
                  textShadow: "4px 2px 8px rgba(0,0,0,0.7)",
                  marginBottom: "16px",
                }}
                >
                  Kinemo Agro Seeds & Chemical Traders Co. LTD
              </h1>
              <p
                className="text-light font-light font-semi-bold py-2 my-5"
                data-aos="fade-up"
                style={{
                  fontSize: "clamp(16px, 2vw, 20px)",
                  lineHeight: 1.5,
                  textShadow: "1px 1px 6px rgba(0,0,0,0.75)",
                }}
              >
                We deliver climate-resilient seeds, quality poultry inputs, and innovative agribusiness solutions that empower farmers, boost productivity, and strengthen sustainable food systems across Tanzania and beyond.
              </p>

              {/* CTA */}
              <button
                className="text-light py-2 px-0"
                onClick={() => appContext.navTo({ item: "contact_us" })}
                style={{
                  transition: ".5s all ease",
                  background: "transparent",
                  border: "none",
                  borderBottom: "2px solid var(--lightColor) !important",
                  outline: "none",
                  fontWeight: "bold"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateX(5px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateX(0)";
                }}
              >
                Learn More &nbsp; <FaArrowRight size={22} />
              </button>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
